export function preventDefault(event: Event): void {
  event.preventDefault()
}
